module.exports = __webpack_public_path__ + "h5/img/图层 2.061ccebe.png";